import { CharacterPage } from './CharacterPage'
import { withCharacterPage } from './withCharacterPage'

const ConnectedCharacterPage = withCharacterPage(CharacterPage)

export { ConnectedCharacterPage as CharacterPage }
